import React from 'react';
import type { FC } from 'react';
import { match, isType } from 'variant';
import { Trans } from '@wix/cli-i18n';
import { DeploymentStatus } from '@wix/document-management-client';
import { useAsync, Spinner, Alert, Badge, Link } from '@wix/cli-ui-kit';
import { useCreatePreview } from './useCreatePreview.js';

export const PreviewCommand: FC = () => {
  const createPreview = useCreatePreview();

  const { status } = useAsync(async () => {
    const { previewUrl, deploymentStatus } = await createPreview();

    if (isType(deploymentStatus, DeploymentStatus.Error)) {
      throw deploymentStatus.deploymentError;
    }

    return previewUrl;
  }, []);

  return match(status, {
    Error: () => null,
    Loading: () => (
      <Spinner text={<Trans i18nKey="preview_command.loading" />} />
    ),
    Success: ({ result: previewUrl }) => (
      <Alert type="success">
        <Badge skin="success">
          <Trans i18nKey="general.success" />
        </Badge>{' '}
        <Trans
          i18nKey="preview_command.success"
          components={[<Link url={previewUrl} />]}
        />
      </Alert>
    ),
  });
};
